import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const inputClasses = "w-full px-4 py-4 rounded-lg text-gray-800 font-medium text-lg border-2 border-gray-300 focus:border-brand focus:outline-none transition-colors";

const VenuesContact = () => {
  const { t } = useTranslation();
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    const form = e.target;
    try {
      const response = await fetch('https://formspree.io/f/mjkabjey', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });
      if (response.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="bg-gray-900 py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('venues.contact.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            {t('venues.contact.subtitle')}
          </p>
        </div>

        <div className="tk-card max-w-2xl mx-auto">
          {status === 'success' ? (
            <div className="text-center py-12">
              <p className="text-2xl font-bold text-brand mb-4">✅ {t('venues.contact.success')}</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <input type="hidden" name="_subject" value="Nuevo lead: Tenku Venues" />
              <input type="hidden" name="source" value="venues-landing" />

              <div>
                <label htmlFor="venues-name" className="block text-white font-semibold mb-2">
                  {t('venues.contact.name')}
                </label>
                <input
                  type="text"
                  id="venues-name"
                  name="name"
                  placeholder={t('venues.contact.namePlaceholder')}
                  required
                  className={inputClasses}
                />
              </div>

              <div>
                <label htmlFor="venues-venue" className="block text-white font-semibold mb-2">
                  {t('venues.contact.venueName')}
                </label>
                <input
                  type="text"
                  id="venues-venue"
                  name="venue"
                  placeholder={t('venues.contact.venueNamePlaceholder')}
                  required
                  className={inputClasses}
                />
              </div>

              <div>
                <label htmlFor="venues-city" className="block text-white font-semibold mb-2">
                  {t('venues.contact.city')}
                </label>
                <input
                  type="text"
                  id="venues-city"
                  name="city"
                  placeholder={t('venues.contact.cityPlaceholder')}
                  required
                  className={inputClasses}
                />
              </div>

              <div>
                <label htmlFor="venues-phone" className="block text-white font-semibold mb-2">
                  {t('venues.contact.phone')}
                </label>
                <input
                  type="tel"
                  id="venues-phone"
                  name="phone"
                  placeholder={t('venues.contact.phonePlaceholder')}
                  required
                  className={inputClasses}
                />
              </div>

              <div>
                <label htmlFor="venues-email" className="block text-white font-semibold mb-2">
                  {t('venues.contact.email')}
                </label>
                <input
                  type="email"
                  id="venues-email"
                  name="email"
                  placeholder={t('venues.contact.emailPlaceholder')}
                  className={inputClasses}
                />
              </div>

              <div>
                <label htmlFor="venues-message" className="block text-white font-semibold mb-2">
                  {t('venues.contact.message')}
                </label>
                <textarea
                  id="venues-message"
                  name="message"
                  rows="3"
                  placeholder={t('venues.contact.messagePlaceholder')}
                  className={`${inputClasses} resize-none`}
                ></textarea>
              </div>

              {status === 'error' && (
                <p className="text-center text-brand font-semibold">
                  {t('venues.contact.error')}
                </p>
              )}

              <button
                type="submit"
                disabled={status === 'sending'}
                className="w-full bg-brand hover:bg-brand-dark text-white font-bold py-4 px-8 rounded-lg text-xl transition-all duration-300 inline-flex items-center justify-center space-x-3 shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
              >
                <span>{status === 'sending' ? t('venues.contact.sending') : t('venues.contact.submit')}</span>
              </button>
            </form>
          )}

          <div className="mt-6 text-center">
            <p className="text-gray-400 text-sm">
              {t('venues.contact.privacy')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VenuesContact;
